export const NAV_ITEMS = [
  { name: 'trip-overview', label: '總覽', icon: '🏠' },
  { name: 'trip-places', label: '地點', icon: '📍' },
  { name: 'trip-votes', label: '投票', icon: '🗳️' },
  { name: 'trip-infobox', label: '資料收集箱', icon: '🗂️' },
  { name: 'trip-todos', label: '待辦', icon: '✅' },
  { name: 'trip-finance', label: '財務', icon: '💰' },
  { name: 'trip-timeline', label: '時間線', icon: '🕒' },
  { name: 'trip-memory', label: 'Memory Box', icon: '🖼️' },
  { name: 'trip-map', label: '地圖', icon: '🗺️' },
  { name: 'trip-members', label: '成員', icon: '👥' }
]

// 手機版底部只放最常用的 4 個 + 更多
export const MOBILE_PRIMARY = ['trip-overview', 'trip-places', 'trip-timeline', 'trip-finance']
